import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=3d5a57b9&scoped=true&"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&id=3d5a57b9&prod&lang=scss&scoped=true&"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&id=3d5a57b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a57b9",
  null
  
)

export default component.exports